import { Button, Card, Divider } from "@mui/material";
import React from "react";

import TransactionTable from "../Transaction/TransactionTable";
import { useAppSelector } from "../../../State/Store";
import { Transaction } from "../../../types/transactionType";
import { useNavigate } from "react-router-dom";

export const Payment = () => {
  const {transaction}=useAppSelector(store=>store)
  const navigate = useNavigate()
  const handleSum = (transactions:Transaction[]) => { 
 return transactions.reduce((accumulator,item)=>{
    return accumulator + (item.sellingPrice ?? 0); 
  },0)

  
   }
   const getLastPayment = (transactions: Transaction[]) => {
    if (transactions.length === 0) return 0; // Handle case when no transactions exist
    const lastTransaction = transactions[transactions.length - 1];
    return lastTransaction.sellingPrice ?? 0;
  };

  return (
    <div className="space-y-5">
      <Card className="rounded-md space-y-4 p-5">
        <h1 className="text-gray-600 font-medium">Total Earning</h1>
        <h1 className="font-bold text-xl pb-1">{handleSum(transaction.transactions)}€</h1>

        <Divider/>
        <p className="text-gray-600 font-medium pt-1">Last Payment: <strong>{getLastPayment(transaction.transactions)}€</strong></p>
      </Card>
      <div className="pt-20 space-y-3">
      <Button onClick={() => { 
        navigate("/seller/transaction")
       }} variant="contained">
        Transaction
      </Button>
      <TransactionTable/>
      </div>
    </div>
  );
};
